import { env } from '../config';
import { useState, useEffect } from 'react';
import { findGmapsState, findGmapsCountry, findGmapsCity, getTimezone } from '../utils';

const AddressField = ({
    error,
    existingLocation,
    placeholder,
    editLocation,
    searchValue,
    setIsLocationEdited,
    disabled=false
}) => {

    const [isActive, setIsActive] = useState(null);
    const [searchResults, setResults] = useState(null);
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [searchLocation, setSearchLocation] = useState(searchValue || '');

    useEffect(() => {
        setSearchLocation(searchValue)
    }, [searchValue])

    function onFocusEvent(e) {
        setIsActive(true);
    }

    async function onChangeEvent(e) {
        clearTimeout(searchTimeout); 
        const val = e.target.value || '';
        setSearchLocation(val)


        if (!val) return null; // The user has zeroed out the field, keeps the last search results up
        setIsActive(true);
        try {
            setSearchTimeout(setTimeout(async() => {
                await search(val);
            }, 1000))
            
        } catch (e) {
            console.error(e);
        }
    }

    async function onSelect(location) {
        editLocation({
            ...existingLocation,
            address: location?.address,
            address1: location?.address1,
            city: location?.city,
            country: location?.country,
            latitude: location?.latitude,
            longitude: location?.longitude,
            state: location?.state,
            timezone: await getTimezone(location?.latitude, location?.longitude),
            zip: location?.zip
        });
        setSearchLocation(location?.address);
        setIsActive(false);
        setResults(null);
        setIsLocationEdited(true);
    }

    async function search(searchString) {
        return new Promise(async (resolve, reject) => {
            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${searchString}&key=${env.GMAPS_KEY}`

            return fetch(url)
            .then(addresses => addresses.json())
            .then(results => {
                if (results.status === 'OK') {
                    const newResults = results.results.slice(0,5).map((result) => {
                        const city = findGmapsCity(result.address_components);
                        const state = findGmapsState(result.address_components);
                        const zip = result.address_components.find(item => item.types.includes('postal_code'));
                        const address1 = result.formatted_address.split(',')[0];
                        return {
                            name: address1,
                            address: result.formatted_address,
                            address1,
                            city,
                            latitude: result.geometry?.location?.lat || null,
                            longitude: result.geometry?.location?.lng || null,
                            state: state,
                            zip: zip?.long_name,
                            country: findGmapsCountry(result.address_components)?.short_name,
                        }
                    });
                    setResults(newResults);
                    resolve(newResults)
                }
                return;
            })
        })
    }

    function Results({ searchResults }) {
        if (!searchResults) return null;
        return searchResults.map((result, i) => {
            if (!result) return null;
            return (
                <div className="results" key={i}>
                    <button className="select-item" onClick={() => onSelect(result)}>
                        {result.name}
                        <div className="select-item-address">{result.address}</div>
                    </button>
                </div>
            )
        });
    }

    return (
        <div className="AddressField">
            <div className="search-container">
                <input
                    className={`location-input ${error ? "error" : ""}`}
                    type="search"
                    value={searchLocation || ''}
                    placeholder={placeholder}
                    onFocus={onFocusEvent}
                    onChange={(e) => { onChangeEvent(e)} }
                    autoComplete="off"
                    data-lpignore="true"
                    v-model="filter"
                    data-1p-ignore={true}
                    disabled={disabled}
                    />
                <div className="results-container">
                    <Results searchResults={searchResults} />
                </div>
            </div>
        </div>
    );
}

export default AddressField;
